import { render, staticRenderFns } from "./Planogram.vue?vue&type=template&id=6051382e&"
import script from "./Planogram.vue?vue&type=script&lang=js&"
export * from "./Planogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports